'use strict';

var pdfobjectversion = '2.2.7';
var nav = window.navigator;
var ua = window.navigator.userAgent;
var isIE = 'ActiveXObject' in window;
var isModernBrowser = window.Promise !== undefined;
var supportsPdfMimeType = nav.mimeTypes['application/pdf'] !== undefined;
var isSafariIOSDesktopMode = nav.platform !== undefined && nav.platform === 'MacIntel' && nav.maxTouchPoints !== undefined && nav.maxTouchPoints > 1;
var isMobileDevice = isSafariIOSDesktopMode || /Mobi|Tablet|Android|iPad|iPhone/.test(ua);
var isSafariDesktop = !isMobileDevice && nav.vendor !== undefined && /Apple/.test(nav.vendor) && /Safari/.test(ua);
var isFirefoxWithPDFJS = !isMobileDevice && /irefox/.test(ua) && ua.split('rv:').length > 1 ? parseInt(ua.split('rv:')[1].split('.')[0], 10) > 18 : false;
var createAXO = function createAXO(type) {
    var ax;
    try {
        ax = new ActiveXObject(type);
    } catch (e) {
        ax = null;
    }
    return ax;
};
var supportsPdfActiveX = function supportsPdfActiveX() {
    return !!(createAXO('AcroPDF.PDF') || createAXO('PDF.PdfCtrl'));
};
var supportsPDFs = !isMobileDevice && (isModernBrowser || isFirefoxWithPDFJS || supportsPdfMimeType || (isIE && supportsPdfActiveX()));
var buildURLFragmentString = function buildURLFragmentString(pdfParams) {
    var string = '';
    var prop;
    if (pdfParams) {
        for(prop in pdfParams){
            if (pdfParams.hasOwnProperty(prop)) {
                string += encodeURIComponent(prop) + '=' + encodeURIComponent(pdfParams[prop]) + '&';
            }
        }
        if (string) {
            string = '#' + string;
            string = string.slice(0, string.length - 1);
        }
    }
    return string;
};
var embedError = function embedError(msg, suppressConsole) {
    if (!suppressConsole) {
        console.log('[PDFObject] ' + msg);
    }
    return false;
};
var emptyNodeContents = function emptyNodeContents(node) {
    while(node.firstChild){
        node.removeChild(node.firstChild);
    }
};
var getTargetElement = function getTargetElement(targetSelector) {
    var targetNode = document.body;
    if (typeof targetSelector === 'string') {
        targetNode = document.querySelector(targetSelector);
    } else if (window.jQuery !== undefined && targetSelector instanceof window.jQuery && targetSelector.length) {
        targetNode = targetSelector.get(0);
    } else if (targetSelector.nodeType !== undefined && targetSelector.nodeType === 1) {
        targetNode = targetSelector;
    }
    return targetNode;
};
var generatePDFJSMarkup = function generatePDFJSMarkup(targetNode, url, pdfOpenFragment, PDFJS_URL, id, title, omitInlineStyles) {
    emptyNodeContents(targetNode);
    var fullURL = PDFJS_URL + '?file=' + encodeURIComponent(url) + pdfOpenFragment;
    var div = document.createElement('div');
    var iframe = document.createElement('iframe');
    iframe.src = fullURL;
    iframe.className = 'pdfobject';
    iframe.type = 'application/pdf';
    iframe.frameborder = '0';
    iframe.allow = 'fullscreen';
    iframe.title = title;
    if (id) {
        iframe.id = id;
    }
    if (!omitInlineStyles) {
        div.style.cssText = 'position: absolute; top: 0; right: 0; bottom: 0; left: 0;';
        iframe.style.cssText = 'border: none; width: 100%; height: 100%;';
        targetNode.style.position = 'relative';
        targetNode.style.overflow = 'auto';
    }
    div.appendChild(iframe);
    targetNode.appendChild(div);
    targetNode.classList.add('pdfobject-container');
    return targetNode.getElementsByTagName('iframe')[0];
};
var generatePDFObjectMarkup = function generatePDFObjectMarkup(embedType, targetNode, targetSelector, url, pdfOpenFragment, width, height, id, title, omitInlineStyles) {
    emptyNodeContents(targetNode);
    var embed = document.createElement(embedType);
    embed.src = url + pdfOpenFragment;
    embed.className = 'pdfobject';
    embed.type = 'application/pdf';
    embed.title = title;
    if (id) {
        embed.id = id;
    }
    if (embedType === 'iframe') {
        embed.allow = 'fullscreen';
    }
    if (!omitInlineStyles) {
        var style = embedType === 'embed' ? 'overflow: auto;' : 'border: none;';
        if (targetSelector && targetSelector !== document.body) {
            style += 'width: ' + width + '; height: ' + height + ';';
        } else {
            style += 'position: absolute; top: 0; right: 0; bottom: 0; left: 0; width: 100%; height: 100%;';
        }
        embed.style.cssText = style;
    }
    targetNode.classList.add('pdfobject-container');
    targetNode.appendChild(embed);
    return targetNode.getElementsByTagName(embedType)[0];
};
var embed1 = function embed1(url, targetSelector, options) {
    var selector = targetSelector || false;
    var opt = options || {
    };
    var id = typeof opt.id === 'string' ? opt.id : '';
    var page = opt.page || false;
    var pdfOpenParams = opt.pdfOpenParams || {
    };
    var fallbackLink = opt.fallbackLink || true;
    var width = opt.width || '100%';
    var height = opt.height || '100%';
    var title = opt.title || 'Embedded PDF';
    var assumptionMode = typeof opt.assumptionMode === 'boolean' ? opt.assumptionMode : true;
    var forcePDFJS = typeof opt.forcePDFJS === 'boolean' ? opt.forcePDFJS : false;
    var supportRedirect = typeof opt.supportRedirect === 'boolean' ? opt.supportRedirect : false;
    var omitInlineStyles = typeof opt.omitInlineStyles === 'boolean' ? opt.omitInlineStyles : false;
    var suppressConsole = typeof opt.suppressConsole === 'boolean' ? opt.suppressConsole : false;
    var forceIframe = typeof opt.forceIframe === 'boolean' ? opt.forceIframe : false;
    var PDFJS_URL = opt.PDFJS_URL || false;
    var targetNode = getTargetElement(selector);
    var fallbackHTML = '';
    var pdfOpenFragment = '';
    var fallbackHTML_default = "<p>This browser does not support inline PDFs. Please download the PDF to view it: <a href='[url]'>Download PDF</a></p>";
    if (typeof url !== 'string') {
        return embedError('URL is not valid', suppressConsole);
    }
    if (!targetNode) {
        return embedError('Target element cannot be determined', suppressConsole);
    }
    if (page) {
        pdfOpenParams.page = page;
    }
    pdfOpenFragment = buildURLFragmentString(pdfOpenParams);
    if (forcePDFJS && PDFJS_URL) {
        return generatePDFJSMarkup(targetNode, url, pdfOpenFragment, PDFJS_URL, id, title, omitInlineStyles);
    }
    if (supportsPDFs || assumptionMode && !isMobileDevice) {
        var embedtype = forceIframe || supportRedirect || isSafariDesktop ? 'iframe' : 'embed';
        return generatePDFObjectMarkup(embedtype, targetNode, targetSelector, url, pdfOpenFragment, width, height, id, title, omitInlineStyles);
    }
    if (PDFJS_URL) {
        return generatePDFJSMarkup(targetNode, url, pdfOpenFragment, PDFJS_URL, id, title, omitInlineStyles);
    }
    if (fallbackLink) {
        fallbackHTML = typeof fallbackLink === 'string' ? fallbackLink : fallbackHTML_default;
        targetNode.innerHTML = fallbackHTML.replace(/\[url\]/g, url);
    }
    return embedError('This browser does not support embedded PDFs', suppressConsole);
};

var PDFObject = {
    embed: function (a, b, c) {
        return embed1(a, b, c);
    },
    pdfobjectversion: pdfobjectversion,
    supportsPDFs: supportsPDFs,
};
export default PDFObject;
